import GuaranteedRentPage from "@/pages/guaranteed-rent/GuaranteedRentPage";
import { getCity } from "@/pages/guaranteed-rent/cityConfig";

export default function GuaranteedRentStoke() {
  return <GuaranteedRentPage city={getCity("stoke-on-trent")} />;
}